import { render, staticRenderFns } from "./RecommendProduct.vue?vue&type=template&id=ef101238&scoped=true&"
import script from "./RecommendProduct.vue?vue&type=script&setup=true&lang=js&"
export * from "./RecommendProduct.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./RecommendProduct.vue?vue&type=style&index=0&id=ef101238&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef101238",
  null
  
)

export default component.exports